import React from "react";
import { Box } from "@mui/material";

// The CSS background of a source paint's swatch: the solid colour, the
// gradient's stops, or a neutral hatch for a raster shape.
export function paintBackground(display) {
  if (!display) return "#cccccc";
  if (display.kind === "solid" && display.hex) return display.hex;
  if (display.kind === "gradient") {
    const stops = (display.stops || []).map(([offset, hex]) => `${hex} ${Math.round(offset * 100)}%`);
    if (stops.length >= 2) return `linear-gradient(90deg, ${stops.join(", ")})`;
    if (stops.length === 1) return display.stops[0][1];
    return "linear-gradient(90deg, #dddddd, #777777)";
  }
  return "repeating-linear-gradient(135deg, #cfd8dc 0 4px, #eceff1 4px 8px)";
}

/** Square swatch showing what a source paint looks like in the uploaded file. */
export default function PaintSwatch({ display, size = 28, sx = {} }) {
  return (
    <Box
      aria-hidden
      sx={{
        width: size, height: size, flexShrink: 0, borderRadius: 1,
        border: "1px solid rgba(15, 23, 42, 0.2)",
        background: paintBackground(display),
        ...sx,
      }}
    />
  );
}
